// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {Scenario, ScenarioGroupView} from "@models";
import {SimConfigurationService, SimMaterialDialogService, SimScenarioService} from "@services";
import {Translations} from "@translations";
import {VMAutoCompleteGroup, VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-scenario-chip-input",
	templateUrl: "./sim-scenario-chip-input.component.html",
	styleUrls: ["./sim-scenario-chip-input.component.scss"],
	standalone: false,
})
export class SimScenarioChipInputComponent implements OnInit {
	T = Translations;

	@Input() scenarioFc: FormArray<FormControl<Scenario>>;

	@Input() label: string;
	@Input() placeholder: string;

	@Input() isDisabled = false;
	@Input() isAutofocusEnabled = false;
	@Input() canSelectMultipleScenarios = false;
	@Input() preselectDefaultScenario = false;

	optionSelected = output<Scenario>();
	optionCleared = output<void>();

	autoCompleteGroupedData: VMAutoCompleteGroup<Scenario>[] = [];

	private _availableScenarios: ScenarioGroupView[] = [];
	settings = SimConfigurationService.settings;

	constructor(
		private _simScenarioService: SimScenarioService,
		private _simMaterialDialog: SimMaterialDialogService,
	) {}

	ngOnInit(): void {
		this._simScenarioService.getScenariosGrouped().then((scenarioGroups) => {
			this._availableScenarios = scenarioGroups;
			if (this.preselectDefaultScenario) {
				this._preselectDefaultScenario();
			}
			this.reloadAutoCompleteData("");
		});
	}

	reloadAutoCompleteData(searchString: string) {
		this.autoCompleteGroupedData = this._availableScenarios
			.map((scenarioGroup) => {
				let scenarios: VMAutoCompleteNormal<Scenario>[] = scenarioGroup.scenarios
					.filter((scenario) => {
						return scenario.name?.toLowerCase()?.includes(searchString?.toLowerCase()) ?? false;
					})
					.map((room) => {
						return {value: room, displayName: room.name};
					});

				return {
					groupDisplayName: scenarioGroup.name,
					groupValues: scenarios,
				};
			})
			.filter((group) => group.groupValues.length > 0);
	}

	openScenarioDialog(scenario: Scenario) {
		this._simMaterialDialog.openScenarioInformationDialog({
			scenario: scenario,
		});
	}

	private _preselectDefaultScenario() {
		const defaultScenario = this._availableScenarios
			.flatMap((availableScenarioGroup) => availableScenarioGroup.scenarios)
			.find((scenario) => scenario.id === this.settings.defaultIds.scenarioId);

		if (defaultScenario) {
			this.scenarioFc.push(new FormControl(defaultScenario));
		}
	}
}
